import React, { useCallback, useMemo, useState } from 'react'
import IndicatorIcon from '../../assets/icons/indicatorIcon'
import { Indicator } from '../../proto/generated/indicator'
import IndicatorsModal from './IndicatorsModal'
import { ExtraSmallButton } from '../custom'
import { ShortcutsCategories, ShortcutType } from '../KeyboardShortcuts/Shortcuts.types'
import useShortcuts from '../../hooks/useShortcuts'
import { IndicatorDialogShortcutsKeyName } from '../KeyboardShortcuts/ShortcutsKeymap'
import AnalyticsManager from '../../analytics/AnalyticsManager'
import { Tooltip, Box } from '@mui/material'
import { useUser } from '../../context/UserContext'
import { useDispatch } from 'react-redux'
import { FeatureCategory, FeatureSubCategory } from '../adminUserRestrictions/Restrictions.constants'
import { Group, setFeatureRestrictionDialog } from '../../reducer/user.reducer'


interface IndicatorsProps {
    indicators: Indicator[] | undefined;
    onIndicatorClicked: Function;
    disabled?: boolean
    title: string
}

function Indicators(props: IndicatorsProps) {
    const dispatch = useDispatch()
    const [modalOpen, setModalOpen] = useState<boolean>(false)
    const { user: { hasAccess }} = useUser()

    const handleButtonClick = useCallback((event: { preventDefault: () => void }) => {
        if (!props.disabled) {
            event.preventDefault()
            setModalOpen(true)
        }
    }, [props.disabled])

    const handleKeyClick = useCallback((event: { preventDefault: () => void }) => {
        AnalyticsManager.logEvent('Indicator dialog opened', { source: 'keyboard' })
        if (!props.disabled) {
            event.preventDefault()
            setModalOpen(true)
        }
    }, [props.disabled])

    const shortcuts: ShortcutType = useMemo(() => ({
        [IndicatorDialogShortcutsKeyName.openIndicatorDialog]: handleKeyClick
    }), [handleKeyClick])

    useShortcuts(ShortcutsCategories.INDICATOR_DIALOG, shortcuts)

    const indicatorClicked = useCallback((indicator: Indicator) => {
        if(!hasAccess(FeatureCategory.CHART, FeatureSubCategory.INDICATOR, indicator.code)) {
            dispatch(setFeatureRestrictionDialog({
                open: true,
                feature: indicator.shortName + ' Indicator',
                group: Group.CHART
            }))
            setModalOpen(false)
            return
        }
        props.onIndicatorClicked(indicator)
        if(indicator.candleType==='DRAWING_TOOL') {
            setModalOpen(false)
        }
    }, [props.onIndicatorClicked, hasAccess, dispatch])

    return (
        <div>
            <Tooltip 
            title={
                <span style={{fontSize:'12px'}}>
                    Indicator : 
                    <Box
                       sx={{
                            display: 'inline-block',
                            padding: '2px 6px',
                            fontSize: '12px',
                            color: '#fff',
                            backgroundColor: 'grey',
                            borderRadius: '4px',
                            margin: '0 2px',
                            fontFamily: 'monospace',
                        }}
                    >
                       /
                    </Box>
                </span>
            }
            arrow 
            placement="bottom" 
        >
            <span>
            <ExtraSmallButton
                size="small"
                color="inherit"
                onClick={handleButtonClick}
                disabled={props.disabled}
                data-event={'Indicators Icon Clicked'}
                data-event-source={'stockbar'}
            >
                <IndicatorIcon />
            </ExtraSmallButton>
            </span>
            </Tooltip>
            <IndicatorsModal open={modalOpen} onCloseClicked={() => {
                setModalOpen(false)
            }} onIndicatorClicked={indicatorClicked}
                             indicators={props.indicators?.filter((indicator) => indicator.enabled && indicator.code!=='OI_HISTORICAL_PROFILE')} />
        </div>
    )
}

export default React.memo(Indicators)